import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetCheckRequestProtocol,
	GetCheckRequestProtocolParams,
	GetCheckRequestProtocolResponse,
} from 'domain/usecases';

export class RemoteGetCheckRequestProtocol implements GetCheckRequestProtocol {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetCheckRequestProtocolResponse>,
	) {}

	async get(params: GetCheckRequestProtocolParams): Promise<GetCheckRequestProtocolResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
